import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BuildMoneyProject} from '../../../../class/lifeproject/build-money-project';
import {LifeProjectBaseEditorComponent} from '../life-project-base-editor/life-project-base-editor.component';
import {LifeProject} from '../../../../class/lifeproject/life-project';
import {WelfareResultService} from '../../../../service/welfare-result.service';
import {NbDialogService} from '@nebular/theme';

@Component({
  selector: 'app-build-money',
  templateUrl: './build-money.component.html',
  styleUrls: ['./build-money.component.css']
})
export class BuildMoneyComponent extends LifeProjectBaseEditorComponent implements OnInit {

  @Input()
  buildMoney: BuildMoneyProject;

  @ViewChild('alertDialog')
  alertDialog: TemplateRef<any>;

  result = 0;
  errorMsg: string;

  constructor(welfareService: WelfareResultService, private dialogService: NbDialogService) {
    super(welfareService);
  }

  ngOnInit() {

  }

  private computeResult() {
    if (this.buildMoney.savedMoney < this.buildMoney.futureValue) {

      const i = this.buildMoney.tax / 100;
      let futureValue = 0;

      if (i > 0) {
        const M = this.buildMoney.savedMoney * Math.pow((1 + i), this.buildMoney.yearToGoal);
        futureValue = this.buildMoney.futureValue - M;

        this.buildMoney.value = futureValue * i / (Math.pow(1 + i, this.buildMoney.yearToGoal) - 1);
        this.buildMoney.yearCost = this.buildMoney.value;
      } else {
        futureValue = (this.buildMoney.futureValue - this.buildMoney.savedMoney);
        this.buildMoney.value = futureValue / this.buildMoney.yearToGoal;
        this.buildMoney.yearCost = this.buildMoney.value;
      }

      this.buildMoney.totalCost = this.buildMoney.futureValue - this.buildMoney.savedMoney;
      this.errorMsg = null;
    } else {
      this.errorMsg = 'Attenzione il capitale richiesto e\' minore delle risorse utilizzate';
    }
  }

  calResult() {

    if (this.buildMoney.assets == null || this.buildMoney.assets.length === 0) {
      this.dialogService.open(this.alertDialog,
        {context: 'Non e\' stata inserita nessuna riserva, la riserva dispobible sara\' 0. Vuoi procedere?'})
        .onClose.subscribe(value => {
        if (value) {
          this.buildMoney.savedMoney = 0;
          this.computeResult();
        }
      });
    } else {
      this.computeResult();
    }
  }

  getLifeProjectImpl(): LifeProject {
    return this.buildMoney;
  }
}
